import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/byner.webp';
import screenshot_target from '../../../images/letterfunnel/ralphbrasker.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Ralph Brasker"
      firstname="Ralph"
      companyname="Byner"
      competition="Bullhorn en Carerix"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/ralphbrasker.js